import { render, staticRenderFns } from "./CounterpartyPrimaryAddress.vue?vue&type=template&id=87312c98"
import script from "./CounterpartyPrimaryAddress.vue?vue&type=script&lang=js"
export * from "./CounterpartyPrimaryAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports